module.exports = __webpack_public_path__ + "img/stock.1631b900.svg";